<script setup lang="ts">
  import { computed } from 'vue';
  import { useShared } from '@othercommerce/foundation';

  const shared = useShared();

  const department = computed(() => {
    return shared.value.department;
  });

  const phone = computed(() => {
    if (department.value) {
      return `tel:${department.value.phone}`;
    }
  });
</script>
<template>
  <SfButton v-if="department" :href="phone" class="order-header-phone" transparent>
    <template #before>
      <SfIconTelephone aria-hidden="true" />
    </template>
    <template #default>
      {{ department.phone }}
    </template>
  </SfButton>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  @include media.query(lg) {
    .order-header-phone {
      --sf-btn-font-size: 0.875rem;
      padding-right: 0.25rem;
    }
  }
</style>
